/*
  pillar-top-picks.js
  Vertically centers the Top Picks carousel arrows on the product CARD, not on
  the whole badge + card + why slide. The arrows overlay is centered on the
  slider box in CSS (align-items:center); the card sits high in the slide (the
  "why" line adds variable height below it), so centering on the slide lands the
  arrows too low. This measures the offset from the slider's vertical center to
  the card's own center and writes it to --pillar-picks-arrow-y, which the
  translate rules in section-main-pillar.css consume. Purely a layout refinement
  — the carousel itself is driven by <infinite-carousel>.

  Recomputed whenever geometry can change: initial paint, image load, viewport
  resize, and (via ResizeObserver) async card growth such as the review widget
  hydrating. Falls back to 0 (slide-center) before this runs.
*/
(function () {
  var CARD_SELECTOR =
    '.pillar-top-picks__item best-seller-card, .pillar-top-picks__item .bsh__card';

  function centerArrows(section) {
    var slider = section.querySelector('.pillar-top-picks__slider');
    if (!slider) return;
    var card = slider.querySelector(CARD_SELECTOR);
    if (!card) return;
    var s = slider.getBoundingClientRect();
    var c = card.getBoundingClientRect();
    if (!s.height || !c.height) return;
    var offset = c.top + c.height / 2 - (s.top + s.height / 2);
    slider.style.setProperty('--pillar-picks-arrow-y', Math.round(offset) + 'px');
  }

  function init(section) {
    centerArrows(section);
    if (typeof ResizeObserver === 'function') {
      var slider = section.querySelector('.pillar-top-picks__slider');
      var card = slider && slider.querySelector(CARD_SELECTOR);
      if (slider && card) {
        var ro = new ResizeObserver(function () {
          centerArrows(section);
        });
        ro.observe(slider);
        ro.observe(card);
      }
    }
  }

  function run() {
    document.querySelectorAll('.pillar-top-picks').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
})();
